<div class="user-profile" #popupRef>
    <h2 id="user-profile-title" class="sr-only">Brugerprofil</h2>
    <button
        id="user-profile-button"
        [classList]="isOpen ? 'is-active user-profile__profile-button' : 'user-profile__profile-button'"
        (click)="toggleUserProfile()"
        [attr.aria-label]="isOpen ? 'Luk bruger menu' : 'Åben bruger menu'"
        [attr.aria-expanded]="isOpen"
        aria-haspopup="true"
        aria-controls="user-profile-menu"
        type="button"
        role="button"
        [attr.data-testid]="userProfileButtonId"
    >
        <mat-icon class="material-symbols-outlined" aria-hidden="true">account_circle</mat-icon>
    </button>

    @if (isOpen && (user || currentUserValue)) {
        <div (click)="toggleUserProfile()" class="overlay" @fadeInOut></div>
        <div
            class="dropdown-menu"
            id="user-profile-menu"
            aria-labelledby="user-profile-button"
            aria-hidden="false"
            @slideInFromRight
            [attr.data-testid]="userProfileMenuId"
            role="region"
            cdkTrapFocus
            [cdkTrapFocusAutoCapture]="true"
            aria-labelledby="user-profile-title"
        >
            <button class="user-profile__close-button" (click)="toggleUserProfile()" [attr.aria-label]="'Luk bruger menu'" type="button" role="button">
                <mat-icon class="material-symbols-outlined" aria-hidden="true">close</mat-icon>
            </button>
            @if (user) {
                <div class="dropdown-menu__menu-col" aria-live="polite" aria-atomic="true">
                    @if (isSubmitting) {
                        <mat-spinner class="loading" aria-label="Indlæser brugerdata" role="alert"></mat-spinner>
                    }
                    @if (isMobile) {
                        <mat-select
                            [value]="currentUserValue?.fullname"
                            id="mobile-contact-picker"
                            data-testid="mobile-contact-picker"
                            class="dropdown-menu__mobile-person-picker"
                            aria-label="Vælg kontaktperson"
                        >
                            @for (person of contactPersons; track $index) {
                                <mat-option
                                    [value]="person.fullname"
                                    [attr.data-username]="person.fullname"
                                    [attr.data-email]="person.emailAddress1"
                                    [attr.data-testid]="'contact-person-' + person.contactId"
                                    (click)="setContactPerson(person)"
                                    (keyup.enter)="setContactPerson(person)"
                                    [attr.aria-label]="'Vælg kontaktperson: ' + person.fullname"
                                >
                                    {{ person.fullname }}
                                </mat-option>
                            }
                        </mat-select>
                    }

                    @if (!isMobile) {
                        <p id="user-profile-name">
                            Navn: <strong>{{ currentUserValue?.fullname }}</strong>
                        </p>
                    }
                    <p id="user-profile-email">
                        E-mail: <strong>{{ currentUserValue?.emailAddress1 }}</strong>
                    </p>
                    <h2 id="user-profile-form-title" class="sr-only">Rediger brugeroplysninger for {{ currentUserValue?.fullname }}</h2>
                    <form
                        id="user-profile-form"
                        class="mat-form"
                        [class]="isSubmitting ? 'is-loading' : ''"
                        (ngSubmit)="onSubmit(currentUserValue?.contactId)"
                        [formGroup]="userDataForm"
                        [attr.data-testid]="userDataFormTestId"
                        aria-labelledby="user-profile-form-title"
                    >
                        <div class="mat-form__field">
                            <mat-form-field>
                                <mat-label id="form-label-mobilephone">{{ getDictionaryItem("mobilePhone") }}</mat-label>
                                <input
                                    matInput
                                    id="form-field-mobilephone"
                                    type="tel"
                                    name="mobilephone"
                                    formControlName="mobilephone"
                                    aria-labelledby="form-label-mobilephone error-mobilephone"
                                    [attr.aria-invalid]="userDataForm.get('mobilephone')?.invalid"
                                    [attr.aria-required]="false"
                                />
                                @if (userDataForm.get("mobilephone")?.invalid) {
                                    <mat-error id="error-mobilephone">
                                        {{ getDictionaryItem("mobilePhone") }} skal være præcis 8 cifre langt, hvis det udfyldes.
                                    </mat-error>
                                }
                            </mat-form-field>
                            <button
                                mat-icon-button
                                [attr.aria-label]="
                                    userDataForm.get('mobilephone')?.enabled ? 'Deaktiver redigering af telefonnummer' : 'Aktiver redigering af telefonnummer'
                                "
                                (click)="userDataForm.get('mobilephone')?.enabled ? disabledFieldState('mobilephone', true) : enableFieldState('mobilephone', true)"
                                role="button"
                                type="button"
                                tabindex="0"
                            >
                                <mat-icon class="material-symbols-outlined" aria-hidden="true">{{
                                    userDataForm.get("mobilephone")?.enabled ? "close" : "edit"
                                }}</mat-icon>
                            </button>
                        </div>

                        <div class="mat-form__field">
                            <mat-form-field>
                                <mat-label id="form-label-landlinePhone">{{ getDictionaryItem("phoneNumber3") }}</mat-label>
                                <input
                                    matInput
                                    id="form-field-landlinePhone"
                                    type="tel"
                                    name="landlinePhone"
                                    formControlName="landlinePhone"
                                    aria-labelledby="form-label-landlinePhone error-landlinePhone"
                                    [attr.aria-invalid]="userDataForm.get('landlinePhone')?.invalid"
                                    [attr.aria-required]="false"
                                />
                                @if (userDataForm.get("landlinePhone")?.invalid) {
                                    <mat-error id="error-landlinePhone">
                                        {{ getDictionaryItem("phoneNumber3") }} skal være præcis 8 cifre langt, hvis det udfyldes.
                                    </mat-error>
                                }
                            </mat-form-field>
                            <button
                                mat-icon-button
                                [attr.aria-label]="
                                    userDataForm.get('landlinePhone')?.enabled ? 'Deaktiver redigering af telefonnummer 2' : 'Aktiver redigering af telefonnummer 2'
                                "
                                (click)="userDataForm.get('landlinePhone')?.enabled ? disabledFieldState('landlinePhone', true) : enableFieldState('landlinePhone', true)"
                                role="button"
                                type="button"
                                tabindex="0"
                            >
                                <mat-icon class="material-symbols-outlined" aria-hidden="true">{{
                                    userDataForm.get("landlinePhone")?.enabled ? "close" : "edit"
                                }}</mat-icon>
                            </button>
                        </div>

                        <div class="mat-form__field">
                            <mat-form-field>
                                <mat-label id="form-label-smsadvertisement">{{ getDictionaryItem("smsAdvertisement") }}</mat-label>
                                <input
                                    matInput
                                    id="form-field-smsadvertisement"
                                    type="tel"
                                    name="svk_smsnotificationnumber"
                                    formControlName="svk_smsnotificationnumber"
                                    aria-labelledby="form-label-smsadvertisement error-smsnotificationnumber"
                                    [attr.aria-invalid]="userDataForm.get('svk_smsnotificationnumber')?.invalid"
                                    [attr.aria-required]="false"
                                />
                                @if (userDataForm.get("svk_smsnotificationnumber")?.invalid) {
                                    <mat-error id="error-smsnotificationnumber">
                                        {{ getDictionaryItem("mobilePhone") }} skal være præcis 8 cifre langt, hvis det udfyldes.
                                    </mat-error>
                                }
                            </mat-form-field>
                            <button
                                mat-icon-button
                                [attr.aria-label]="
                                    userDataForm.get('svk_smsnotificationnumber')?.enabled
                                        ? 'Deaktiver redigering af SMS adviseringsnummer'
                                        : 'Aktiver redigering af SMS adviseringsnummer'
                                "
                                (click)="
                                    userDataForm.get('svk_smsnotificationnumber')?.enabled
                                        ? disabledFieldState('svk_smsnotificationnumber', true)
                                        : enableFieldState('svk_smsnotificationnumber', true)
                                "
                                role="button"
                                type="button"
                                tabindex="0"
                            >
                                <mat-icon class="material-symbols-outlined" aria-hidden="true">{{
                                    userDataForm.get("svk_smsnotificationnumber")?.enabled ? "close" : "edit"
                                }}</mat-icon>
                            </button>
                        </div>

                        <div class="mat-form__field">
                            <mat-form-field>
                                <mat-label id="form-label-preferredContactMethod"> {{ getDictionaryItem("choseContactMethod") }} </mat-label>
                                <mat-select
                                    name="preferredContactMethod"
                                    formControlName="preferredContactMethod"
                                    id="form-field-preferredContactMethod"
                                    aria-labelledby="form-label-preferredContactMethod"
                                >
                                    @for (method of contactMethods; track $index) {
                                        <mat-option [attr.id]="'method-' + method.value" [value]="method.value">
                                            {{ getLocalizedLabel(method.label)?.Label === "Ethvert" ? "Alle" : getLocalizedLabel(method.label)?.Label }}
                                        </mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>
                            <button
                                mat-icon-button
                                [attr.aria-label]="
                                    userDataForm.get('preferredContactMethod')?.enabled
                                        ? 'Deaktiver redigering af foretrukken kontaktmetode'
                                        : 'Aktiver redigering af foretrukken kontaktmetode'
                                "
                                (click)="
                                    userDataForm.get('preferredContactMethod')?.enabled
                                        ? disabledFieldState('preferredContactMethod', true)
                                        : enableFieldState('preferredContactMethod', true)
                                "
                                role="button"
                                type="button"
                                tabindex="0"
                            >
                                <mat-icon class="material-symbols-outlined" aria-hidden="true">{{
                                    userDataForm.get("preferredContactMethod")?.enabled ? "close" : "edit"
                                }}</mat-icon>
                            </button>
                        </div>

                        <div class="mat-form__field">
                            <mat-form-field>
                                <mat-label id="form-label-title"> {{ getDictionaryItem("choseWorksArea") }} </mat-label>
                                <mat-select id="form-field-title" aria-labelledby="form-label-title" name="title" formControlName="title">
                                    @for (title of contactTitles; track $index) {
                                        <mat-option [attr.id]="'title-' + title.value" [value]="title.value" [disabled]="title.value.toString().startsWith('1')">
                                            {{ getLocalizedLabel(title.label, 1033)?.Label }}
                                        </mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>
                            @if (!this.currentUserValue?.title?.toString()?.startsWith("1")) {
                                <button
                                    mat-icon-button
                                    [attr.aria-label]="
                                        userDataForm.get('title')?.enabled ? 'Deaktiver redigering af arbejdsområde' : 'Aktiver redigering af arbejdsområde'
                                    "
                                    (click)="userDataForm.get('title')?.enabled ? disabledFieldState('title', true) : enableFieldState('title', true)"
                                    role="button"
                                    type="button"
                                    tabindex="0"
                                >
                                    <mat-icon class="material-symbols-outlined" aria-hidden="true">{{ userDataForm.get("title")?.enabled ? "close" : "edit" }}</mat-icon>
                                </button>
                            }
                        </div>

                        <div class="mat-form__field">
                            <mat-form-field>
                                <mat-label id="form-label-contactgroups"> {{ getDictionaryItem("choseContactGroup") }} </mat-label>
                                <mat-select
                                    multiple
                                    id="form-field-contactgroups"
                                    name="contactgroups"
                                    formControlName="contactgroups"
                                    aria-labelledby="form-label-contactgroups"
                                >
                                    @for (group of contactGroups; track $index) {
                                        <mat-option [attr.id]="'group-' + group.value" [value]="group.value" [disabled]="group.value.toString().startsWith('1')">
                                            {{ getLocalizedLabel(group.label, 1033)?.Label }}
                                        </mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>
                            @if (!this.currentUserValue?.contactgroups?.toString()?.startsWith("1")) {
                                <button
                                    mat-icon-button
                                    [attr.aria-label]="
                                        userDataForm.get('contactgroups')?.enabled ? 'Deaktiver redigering af kontaktgrupper' : 'Aktiver redigering af kontaktgrupper'
                                    "
                                    (click)="
                                        userDataForm.get('contactgroups')?.enabled ? disabledFieldState('contactgroups', true) : enableFieldState('contactgroups', true)
                                    "
                                    role="button"
                                    type="button"
                                    tabindex="0"
                                >
                                    <mat-icon class="material-symbols-outlined" aria-hidden="true">{{
                                        userDataForm.get("contactgroup")?.enabled ? "close" : "edit"
                                    }}</mat-icon>
                                </button>
                            }
                        </div>

                        <button
                            id="user-profile-submit-button"
                            type="submit"
                            mat-button
                            class="cta-button"
                            [attr.data-testid]="submitButton"
                            [disabled]="userDataForm.invalid || areAllFieldsDisabled()"
                            [attr.aria-disabled]="userDataForm.invalid || areAllFieldsDisabled()"
                            aria-describedby="submit-button-description"
                        >
                            <span>{{ getDictionaryItem("updateUserProfile") }}</span>
                        </button>
                        <p id="submit-button-description" class="sr-only">
                            Klik på knappen for at opdatere dine brugeroplysninger. Knappen er deaktiveret, hvis formularen er ugyldig eller alle felter er deaktiveret.
                        </p>

                        @if (submitSuccess) {
                            <p class="mt-4 success" role="status" aria-live="polite">
                                {{ user === currentUserValue ? "Dine" : currentUserValue?.fullname + "´" }} {{ getDictionaryItem("userDataUpdatedSuccess") }}
                            </p>
                        }
                        @if (submitError) {
                            <p class="mt-4 error" role="alert" aria-live="assertive">
                                {{ getDictionaryItem("userDataUpdatedError") }}
                            </p>
                        }
                    </form>
                </div>
                <div class="dropdown-menu__menu-col right align-items-end">
                    @if (!isMobile) {
                        <p aria-hidden="true"></p>
                        <p aria-hidden="true"></p>
                        @if (contactPersons !== null && contactPersons.length > 0) {
                            <div class="d-flex flex-column align-items-end" [attr.data-testid]="contactPersonsList" aria-labelledby="contact-persons-list-header">
                                <h2 id="contact-persons-list-header">{{ getDictionaryItem("contactPersons") }}</h2>

                                <button
                                    #contactPersonButton
                                    class="dropdown-menu__contact-persons-list-person"
                                    [class]="currentUserValue?.contactId === user.contactId ? 'is-active' : ''"
                                    (click)="setContactPerson(user)"
                                    type="button"
                                    [attr.aria-label]="'Vælg kontaktperson: ' + user.fullname"
                                    [attr.data-username]="user.fullname"
                                    [attr.data-email]="user.emailAddress1"
                                    [attr.data-testid]="'contact-person-' + user.contactId"
                                    tabindex="-1"
                                >
                                    {{ user.fullname }}
                                </button>

                                <ul id="contact-persons-list" class="dropdown-menu__contact-persons-list" role="list" aria-labelledby="contact-persons-list-header">
                                    @for (person of contactPersons; track $index) {
                                        <li>
                                            <button
                                                #contactPersonButton
                                                class="dropdown-menu__contact-persons-list-person"
                                                [class]="currentUserValue?.contactId === person.contactId ? 'is-active' : ''"
                                                (click)="setContactPerson(person)"
                                                type="button"
                                                [attr.aria-label]="'Vælg kontaktperson: ' + person.fullname"
                                                [attr.data-username]="person.fullname"
                                                [attr.data-email]="person.emailAddress1"
                                                [attr.data-testid]="'contact-person-' + person.contactId"
                                                tabindex="-1"
                                            >
                                                {{ person.fullname }}
                                            </button>
                                        </li>
                                    }
                                </ul>
                            </div>
                        }
                        <a
                            [href]="'https://get.teamviewer.com/softvaerket'"
                            class="teamviewer-link"
                            id="teamviewer-link-menu"
                            title="Åben Teamviewer"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <span class="sr-only">{{ getDictionaryItem("openTeamViewer") }}</span>
                            <img [src]="'./assets/images/teamviewer_icon.svg'" alt="Teamviewer Logo" />
                        </a>

                        <a [routerLink]="['/']" (click)="closeUserProfile()" class="quick-link" id="frontpage-link" title="Forside" [attr.aria-label]="'Gå til forsiden'">
                            <span>Mine sager</span>
                            <mat-icon class="material-symbols-outlined" aria-hidden="true">arrow_forward</mat-icon>
                        </a>
                        <a
                            [routerLink]="['/kurser']"
                            (click)="closeUserProfile()"
                            class="quick-link"
                            id="courses-link"
                            title="Kurser"
                            [attr.aria-label]="'Gå til kurser'"
                        >
                            <span>Kurser</span>
                            <mat-icon class="material-symbols-outlined" aria-hidden="true">arrow_forward</mat-icon>
                        </a>
                        <a
                            [routerLink]="['/videns-artikler']"
                            (click)="closeUserProfile()"
                            class="quick-link"
                            id="knowledge-articles-link"
                            title="Videns Artikler"
                            [attr.aria-label]="'Gå til vidensartikler'"
                        >
                            <span>Se vores vejledninger</span>
                            <mat-icon class="material-symbols-outlined" aria-hidden="true">arrow_forward</mat-icon>
                        </a>
                        <a
                            [routerLink]="['/beskedcenter']"
                            (click)="closeUserProfile()"
                            class="quick-link"
                            id="messagecenter-link"
                            title="Beskedcenter"
                            [attr.aria-label]="'Gå til beskedcenter'"
                        >
                            <span>Se alle beskeder</span>
                            <mat-icon class="material-symbols-outlined" aria-hidden="true">arrow_forward</mat-icon>
                        </a>
                    }
                    <app-pwa-guide></app-pwa-guide>
                </div>
            } @else {
                <p>
                    <strong> Der skete en fejl i forbindelse med at hente bruger data. </strong>
                </p>
            }

            <button
                mat-button
                id="logout-button"
                class="cta-button logout-button"
                (click)="logout()"
                type="button"
                role="button"
                [attr.aria-label]="getDictionaryItem('logoutFromApp')"
                [attr.data-testid]="logoutButtonId"
            >
                <span> {{ getDictionaryItem("logoutFromApp").toLocaleUpperCase() }} </span>
            </button>
        </div>
    }
</div>
